import { useEffect, useRef } from "react";

import { browserBackStack } from "./backStack";

/**
 * While `open`, the phone's Back button calls `close` instead of leaving the
 * page — topmost popup first. See `backStack.ts` for how the history is kept
 * clean when the popup is closed any other way.
 *
 * Every primitive in this folder already calls it (Dialog, Peek, Popover,
 * Menu, Select), so a feature only needs it for a popup it draws by hand.
 * `close` may decline — the peek asks before throwing edits away — and Back
 * stays armed for as long as `open` stays true.
 */
export function useBackClose(open: boolean, close: () => void): void {
  const closeRef = useRef(close);
  closeRef.current = close;

  useEffect(() => {
    if (!open) {
      return;
    }
    return browserBackStack()?.register(() => closeRef.current());
  }, [open]);
}
